module.exports = __webpack_public_path__ + "images/product_jalapeno_3.ec0ed687.jpg";